import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { GATEWAY_TIMEOUT } from '../../actions/auth';
import { PAGE_URL } from '../../../utils/constants';
import { querySyncPush } from '../../actions/navigation';

export default action$ => action$.pipe(
  ofType(GATEWAY_TIMEOUT),
  map(() => querySyncPush(PAGE_URL.GATEWAY_TIMEOUT))
);